export const TASK_MODE_NONE = "task_mode_none";
export const TASK_MODE_SOME = "task_mode_some";
export const TASK_MODE_ALL = "task_mode_all";
